import { render, staticRenderFns } from "./OrmUtilitiesView.vue?vue&type=template&id=5eb61da9&scoped=true"
import script from "./OrmUtilitiesView.vue?vue&type=script&lang=js"
export * from "./OrmUtilitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb61da9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb61da9')) {
      api.createRecord('5eb61da9', component.options)
    } else {
      api.reload('5eb61da9', component.options)
    }
    module.hot.accept("./OrmUtilitiesView.vue?vue&type=template&id=5eb61da9&scoped=true", function () {
      api.rerender('5eb61da9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/utilities/orm/OrmUtilitiesView.vue"
export default component.exports